import type {Dispatch, Reducer} from "react";
import { useDebugValue, useReducer} from "react"

import {mergeExisting} from '../util/collections'

function merge<T, U>(a: T, b: U): T & U {
    return Object.assign(Object.create(null), a, b);
}

export function useMergeReducer<TState extends ExtendsObject>(initialState: TState) {
    useDebugValue(initialState, s => Object.keys(s))
    return useReducer<Reducer<TState, Partial<TState>>>(merge, initialState);
}

export function useMergeExistingReducer<TState extends ExtendsObject>(initialState: TState) {
    useDebugValue(initialState, s => Object.keys(s))
    return useReducer<Reducer<TState, Partial<TState>>>(mergeExisting, initialState);
}

export type MergeState<S> = Dispatch<Partial<S>>
